// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Oq6c","fullView":"styles_fullView__2PPl3"};